// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"support-pre-footer_textWrapper__MxobK","ctaContainer":"support-pre-footer_ctaContainer__weRro","ctaButton":"support-pre-footer_ctaButton__RT4qJ"};